document.addEventListener('DOMContentLoaded', function () {
  const buttons = document.querySelectorAll('.el-collection__tag-item');
  const items = document.querySelectorAll('.el-collection__item');

  buttons.forEach(button => {
    button.addEventListener('click', function () {
      buttons.forEach(btn => btn.classList.remove('active'));
      this.classList.add('active');
      const selectedTag = this.dataset.tag;
      items.forEach(item => {
        const tags = item.dataset.tags ? item.dataset.tags.split(',').map(tag => tag.trim()) : [];

        if (selectedTag === 'all') {
          item.style.display = '';
          return;
        }

        if (tags.includes(selectedTag)) {
          item.style.display = '';
        } else {
          item.style.display = 'none';
        }
      });
    });
  });
});
